<nz-modal
  #modalRef
  nzSize
  [(nzVisible)]="isVisible"
  [nzTitle]="'Add Event' | translate"
  (nzOnCancel)="handleCancel()"
  nzCancelText="Cancel"
  nzOkText="Save"
  nzOkType="primary"
  [nzFooter]="null"
  [nzWrapClassName]="'calendar-modal'"
>
  <ng-container *nzModalContent>
    <form [formGroup]="eventForm" (ngSubmit)="submitForm()">
      <nz-divider
        nzPlain
        [nzText]="'General Information' | translate"
        nzOrientation="left"
        nzVariant="solid"
      ></nz-divider>

      <!-- Service Type -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Service Type" | translate }}</label>
          <span class="asterisk">*</span>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <nz-select
            class="inputs event"
            formControlName="appointmentServiceTypeId"
            [nzPlaceHolder]="'Select service type' | translate"
            nzShowSearch
            nzAllowClear
          >
            @for (serviceType of appointmentServiceTypeList; track serviceType)
            {
            <nz-option
              [nzValue]="serviceType.id"
              [nzLabel]="serviceType.name"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Appointment Reason -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Appointment Reason" | translate }}</label>
          <span class="asterisk">*</span>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <nz-select
            class="inputs event"
            formControlName="appointmentReasonId"
            [nzPlaceHolder]="'Select appointment reason' | translate"
            nzShowSearch
            nzAllowClear
          >
            @for (reason of appointmentReasonsList; track reason) {
            <nz-option
              [nzValue]="reason.id"
              [nzLabel]="reason.name"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Title -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Title" | translate }}</label>
          <span class="asterisk">*</span>
        </div>
        <div class="title-control" fxLayout="row" fxLayoutAlign="start center" fxFlex="80">
          <textarea
            nz-input
            rows="3"
            class="inputs event"
            formControlName="title"
            [readonly]="!isTitleEditing"
            [placeholder]="'Enter title' | translate"
            nz-tooltip
            [nzTooltipTitle]="
              'Appointment title generation help' | translate
            "
            [nzTooltipTrigger]="null"
            [nzTooltipVisible]="titleTooltipVisible"
            (mousemove)="onTitleMouseMove($event)"
            (mouseleave)="titleTooltipVisible = false"
          ></textarea>
          <div class="title-actions" fxLayout="row" fxLayoutAlign="start center">
            @if (!isTitleEditing) {
            <i
              nz-icon
              nzType="icons:form"
              nzTheme="outline"
              class="edit-btn"
              (click)="editTitle()"
              [nz-tooltip]="'Edit' | translate"
            ></i>
            } @else {
            <i
              nz-icon
              nzType="check"
              nzTheme="outline"
              class="confirmation-tick"
              (click)="saveTitle()"
              [nz-tooltip]="'Save' | translate"
            ></i>
            <i
              nz-icon
              nzType="close"
              nzTheme="outline"
              class="confirmation-x"
              (click)="cancelTitleEdit()"
              [nz-tooltip]="'Cancel' | translate"
            ></i>
            }
          </div>
        </div>
      </div>

      <!-- Appointment Status -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          @if (!editingEvent) {
          <label
            nz-tooltip
            nzTooltipTitle="
              {{
              'Status can be changed after saving the appointment' | translate
            }}
            "
          >
            {{ "Appointment Status" | translate }}
          </label>
          } @if (editingEvent) {
          <label>
            {{ "Appointment Status" | translate }}
          </label>
          }
          <span class="asterisk">*</span>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <nz-select
            class="inputs event"
            formControlName="appointmentStatusId"
            [nzPlaceHolder]="'Select appointment status' | translate"
            nzShowSearch
            nzAllowClear
            nz-tooltip
            [nzTooltipTitle]="
              !editingEvent
                ? ('Status can be changed after saving the appointment'
                  | translate)
                : null
            "
          >
            @for (status of appointmentStatusList; track status) {
            <nz-option
              [nzValue]="status.id"
              [nzLabel]="status.name"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Description -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Description" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <textarea
            nz-input
            rows="3"
            class="inputs event"
            formControlName="description"
            [placeholder]="'Enter description' | translate"
          ></textarea>
        </div>
      </div>

      <nz-divider
        nzPlain
        [nzText]="'Participants' | translate"
        nzOrientation="left"
        nzVariant="solid"
      ></nz-divider>

      <!-- Department -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
      <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
        <label>{{ "Department" | translate }}</label> -->
      <!-- <span class="asterisk">*</span> CURRENTLY NOT REQUIRED-->
      <!-- </div>
      <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
        <nz-select
          class="inputs event"
          formControlName="department"
          [nzPlaceHolder]="'Select department' | translate"
          nzShowSearch
          nzAllowClear
          >
          <nz-option
            *ngFor="let department of departmentList"
            [nzValue]="department.id"
            [nzLabel]="department.title"
          ></nz-option>
        </nz-select>
      </div>
    </div> -->

      <!-- Department Status -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
    <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
      <label>{{ "Department Status" | translate }}</label>
    </div>
    <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
      <nz-select
        class="inputs event"
        formControlName="departmentStatus"
        nzPlaceHolder="Select Department Status"
        nzShowSearch
        nzAllowClear
        >
        <nz-option
          *ngFor="let status of participantStatusList"
          [nzValue]="status.id"
          [nzLabel]="status.name"
        ></nz-option>
      </nz-select>
    </div>
  </div> -->

      <!-- Roles -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Select role" | translate }}</label
          ><span class="asterisk">*</span>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <nz-select
            nzMode="multiple"
            class="inputs event"
            formControlName="roles"
            [nzPlaceHolder]="'Select role' | translate"
            nzShowSearch
            nzAllowClear
          >
            @for (role of rolesList; track role) {
            <nz-option
              [nzValue]="role.roleId"
              [nzLabel]="role.roleName"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Sub roles -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Select specialty" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <nz-select
            nzMode="multiple"
            class="inputs event"
            formControlName="specialties"
            [nzPlaceHolder]="'Select specialty' | translate"
            nzShowSearch
            nzAllowClear
          >
            @for (specialty of filteredSpecialtiesList; track specialty) {
            <nz-option
              [nzValue]="specialty.roleId"
              [nzLabel]="specialty.roleName"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Personnel -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Select personnel" | translate }}</label
          ><span class="asterisk">*</span>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <nz-select
            nzMode="multiple"
            class="inputs event"
            formControlName="personnel"
            [nzPlaceHolder]="'Select personnel' | translate"
            nzShowSearch
            nzAllowClear
          >
            @for (personnel of filteredPersonnelList; track personnel) {
            <nz-option
              [nzValue]="personnel.userId"
              [nzLabel]="personnel.firstName + ' ' + personnel.lastName"
            ></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Personnel Status -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
  <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
    <label>{{ "Personnel Status" | translate }}</label>
  </div>
  <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
    <nz-select
      class="inputs event"
      formControlName="personnelStatus"
      nzPlaceHolder="Select Personnel Status"
      nzShowSearch
      nzAllowClear
      >
      <nz-option
        *ngFor="let status of participantStatusList"
        [nzValue]="status.id"
        [nzLabel]="status.name"
      ></nz-option>
    </nz-select>
  </div>
</div> -->

      <!-- Patients -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
          <label>{{ "Patients" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
          <nz-select
            nzMode="multiple"
            class="inputs event"
            formControlName="patients"
            [nzPlaceHolder]="'Select patients' | translate"
            nzShowSearch
            nzAllowClear
            [nzDisabled]="isPatientSelectionDisabled"
            [nzLoading]="isPatientOptionsLoading"
            [nzNotFoundContent]="'No available patients' | translate"
            nz-tooltip
            [nzTooltipTitle]="patientSelectionTooltip"
          >
            @for (patient of patientsList; track patient) {
            <nz-option
              [nzValue]="patient.id"
              [nzLabel]="patient.title"
              [nzDisabled]="patient.disabled"
            ></nz-option>
            }
          </nz-select>
          @if (eventForm.get('patients')?.hasError('incompatibleStaffPatients')) {
          <div class="form-error">
            {{
              'Existing patient selection is not available to all selected staff members. Correct the participants before saving.'
                | translate
            }}
          </div>
          }
          @if (eventForm.get('patients')?.hasError('patientOptionsUnavailable')) {
          <div class="form-error">
            {{ 'Unable to load available patients' | translate }}
          </div>
          }
        </div>
      </div>

      <!-- Patient Status -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
<div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
  <label>{{ "Patient Status" | translate }}</label>
</div>
<div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
  <nz-select
    class="inputs event"
    formControlName="patientStatus"
    nzPlaceHolder="Select Patient Status"
    nzShowSearch
    nzAllowClear
    >
    <nz-option
      *ngFor="let status of participantStatusList"
      [nzValue]="status.id"
      [nzLabel]="status.name"
    ></nz-option>
  </nz-select>
</div>
</div> -->

      <!-- Start Date and Time -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
<div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
  <label>{{ "Start Date and Time" | translate }}</label
    ><span class="asterisk">*</span>
  </div>
  <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
    <input
      id="start"
      class="inputs event"
      type="datetime-local"
      formControlName="start"
      />
    </div>
  </div> -->

      <!-- End Date and Time -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
  <div fxFlex="20">
    <label>{{ "End Date and Time" | translate }}</label>
  </div>
  <div fxFlex="80">
    <input
      id="end"
      class="inputs event"
      type="datetime-local"
      formControlName="end"
      />
      -->
      <!-- Error message displayed below the input field --><!--
      <div
        *ngIf="eventForm.errors?.['startAfterEnd']"
        class="error-message"
        >
        <span class="asterisk">*</span> "{{ "End date" | translate }}"
        {{ "must be after" | translate }} "{{ "Start date" | translate }}".
      </div>
    </div>
  </div> -->

      <!-- Slot Status -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
  <div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
    <label>{{ "Slot Status" | translate }}</label>
  </div>
  <div fxLayout="col" fxLayoutAlign="start center" fxFlex="80">
    <nz-select
      class="inputs event"
      formControlName="slotStatus"
      nzPlaceHolder="Select Slot Status"
      nzShowSearch
      nzAllowClear
      >
      <nz-option
        *ngFor="let status of slotStatusList"
        [nzValue]="status.id"
        [nzLabel]="status.name"
      ></nz-option>
    </nz-select>
  </div>
</div> -->

      <nz-divider
        nzPlain
        [nzText]="'Date & Time' | translate"
        nzOrientation="left"
        nzVariant="solid"
      ></nz-divider>

      <!-- Date & Time Selection -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="20">
          <mat-icon class="add-icon">access_time</mat-icon>
        </div>

        <div fxFlex="80">
          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
            <!-- Start Date -->
            <nz-date-picker
              formControlName="startDate"
              [nzFormat]="nz_date_format"
              [nzDisabledDate]="disabledPastDates"
            ></nz-date-picker>

            <!-- Start Time -->
            @if (startTimeVisible) {
            <nz-select
              formControlName="startTime"
              style="min-width: 100px"
              [nzDisabled]="
                !eventForm.value.startDate || eventForm.value.allDay
              "
              [nzAllowClear]="true"
            >
              @for (time of timeOptions; track time) {
              <nz-option [nzValue]="time" [nzLabel]="time"></nz-option>
              }
            </nz-select>
            }

            <!-- Dash -->
            @if (startTimeVisible && endTimeVisible) {
            <div>-</div>
            }

            <!-- End Time -->
            @if (endTimeVisible) {
            <nz-select
              formControlName="endTime"
              style="min-width: 145px"
              [nzDisabled]="
                eventForm.value.allDay ||
                !eventForm.value.startTime ||
                !eventForm.value.startDate
              "
              [nzAllowClear]="true"
            >
              @for (time of timeOptions; track time) {
              <nz-option
                [nzValue]="time"
                [nzLabel]="time + getTimeDiffLabel(time)"
                [nzDisabled]="time <= eventForm.value.startTime"
                [nzHide]="time <= eventForm.value.startTime"
              ></nz-option>
              }
            </nz-select>
            }
          </div>
        </div>
      </div>

      <!-- All Day Event -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
        <div fxFlex="20">
          <label>{{ "All Day Event" | translate }}</label>
        </div>
        <div fxFlex="80">
          <nz-switch
            formControlName="allDay"
            ngDefaultControl
            class="inputs"
          ></nz-switch>
          <!-- Error message displayed below the switch component -->
          @if (eventForm.errors?.['endDateOrAllDayRequired']) {
          <div class="error-message">
            <span class="asterisk">*</span>
            {{ "Please select an" | translate }} "{{ "End date" | translate }}"
            {{ "or" | translate }} "{{ "All Day Event" | translate }}".
          </div>
          }
        </div>
      </div>

      <!-- Event Color -->
      <!-- <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
<div fxLayout="col" fxLayoutAlign="start center" fxFlex="20">
  <label>{{ "Event Color" | translate }}</label
    ><span *ngIf="eventForm.get('eventColor')?.enabled" class="asterisk"
    >*</span
    >
  </div>
  <div fxLayout="column" fxLayoutAlign="start start" fxFlex="80">
    <div class="color-options" fxLayout="row" fxLayoutGap="10px">
      <label
        *ngFor="let color of colorOptions"
        fxLayoutAlign="start center"
        >
        <input
          type="radio"
          formControlName="eventColor"
          [value]="color.value"
          (change)="onColorChange(color.name)"
          />
          <span
            class="color-circle"
                [ngStyle]="{
                  'background-color': color.value,
                  opacity: eventForm.get('eventColor')?.disabled ? 0.2 : 1
                }"
            [class.disabled]="eventForm.get('eventColor')?.disabled"
          ></span>
        </label>
      </div>
      -->
      <!-- Error message below the colors -->
      <!--  <div
      *ngIf="eventForm.get('eventColor')?.disabled"
      class="info-message"
      style="margin-top: 10px"
      >
      ** Event colors are applicable only for All Day events.
    </div>
  </div>
</div> -->
      @if(!editingEvent) {

      <nz-divider
        nzPlain
        [nzText]="'Recurrence' | translate"
        nzOrientation="left"
        nzVariant="solid"
      ></nz-divider>

      <!-- Repeat Event -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start start">
        <div fxFlex="20">
          <label>{{ "Repeat Event" | translate }}</label>
        </div>
        <div fxFlex="80" fxLayout="column" fxLayoutGap="10px">
          <!-- Frequency -->
          <nz-select
            class="inputs event"
            formControlName="recurrenceFrequency"
            [nzPlaceHolder]="'Select frequency' | translate"
          >
            @for (recurrenceFrequency of recurrenceTypeList; track
            recurrenceFrequency) {
            <nz-option
              [nzValue]="recurrenceFrequency.id"
              [nzLabel]="recurrenceFrequency.name"
            ></nz-option>
            }
          </nz-select>

          @if (eventForm.value.recurrenceFrequency != 1) {
          <div fxLayout="row" fxLayoutAlign="start center">
            <label style="margin-right: 10px">{{
              "Repeat for" | translate
            }}</label>
            <input
              nz-input
              type="number"
              formControlName="recurrenceOccurrences"
              min="1"
              step="1"
              [placeholder]="examplePlaceholder"
              style="width: 80px; margin-right: 8px"
            />
            <span>
              {{
                getRecurrenceTypeName(eventForm.value.recurrenceFrequency)
              }}</span
            >
          </div>
          }

          <!-- Repeat Until Validation -->
          @if (eventForm.errors?.['recurrenceOccurrencesRequired']) {
          <div class="error-message">
            <span class="asterisk">*</span>
            {{ "Please enter a valid duration for recurrence" | translate }}.
          </div>
          } @if (eventForm.errors?.['recurrenceOccurrencesExceeded']) {
          <div class="error-message">
            <span class="asterisk">*</span>
            {{ "Max allowed for this frequency" | translate }}:
            {{ eventForm.errors?.['recurrenceOccurrencesExceeded'].max }}
            {{ getRecurrenceTypeName(eventForm.value.recurrenceFrequency) }}.
          </div>
          } @if (eventForm.errors?.['recurrenceUntilBeforeStartOrEnd'] ===
          'start') {
          <div class="error-message">
            <span class="asterisk">*</span>
            {{ "Repeat until" | translate }} must be after
            {{ "start date" | translate }}.
          </div>
          } @if (eventForm.errors?.['recurrenceUntilBeforeStartOrEnd'] ===
          'end') {
          <div class="error-message">
            <span class="asterisk">*</span>
            {{ "Repeat until" | translate }} must be after
            {{ "end date" | translate }}.
          </div>
          } @if (eventForm.errors?.['recurrenceNeedsEndOrAllDay']) {
          <div class="error-message">
            <span class="asterisk">*</span>
            {{
              "You must specify either an end date or enable all-day to repeat"
                | translate
            }}.
          </div>
          }
        </div>
      </div>
      }

      <!-- Show only when editing a recurring event -->
      @if (isEditingRecurring) {
      <div
        style="
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          border-top: 2px solid var(--color-1) !important;
          padding-top: 15px;
        "
      >
        <label style="font-weight: 500">
          <b>
            {{
              "You are about to update a slot from this repeated appointment"
                | translate
            }}
            {{ ": " }}
          </b>
          {{ eventForm.get("title")?.value || ("Not set" | translate) }}
        </label>
        <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-top: 5px">
          <label>
            <input
              type="radio"
              name="updateOption"
              [value]="1"
              formControlName="updateOption"
            />
            <span style="cursor: pointer">
              {{ "This slot only" | translate }}
            </span>
          </label>
          <label>
            <input
              type="radio"
              name="updateOption"
              [value]="2"
              formControlName="updateOption"
            />
            <span style="cursor: pointer">
              {{ "This and all follow-up slots" | translate }}
            </span>
          </label>
          <label>
            <input
              type="radio"
              name="updateOption"
              [value]="3"
              formControlName="updateOption"
            />
            <span style="cursor: pointer">
              {{ "All slots" | translate }}
            </span>
          </label>
        </div>
      </div>
      } @if (!showDiscardConfirm) {
      <div fxLayout="row" fxLayoutAlign="end" class="footer">
        <button
          nz-button
          nzPrimary
          class="save-btn"
          type="submit"
          [nzLoading]="isLoading"
          [disabled]="isLoading || !eventForm.valid"
        >
          {{ "Save" | translate }}
        </button>
        <button
          nz-button
          nzDanger
          class="cancel-btn"
          type="button"
          (click)="handleCancel()"
          [disabled]="isLoading"
        >
          {{ "Cancel" | translate }}
        </button>
      </div>
      } @if (showDiscardConfirm) {
      <div fxLayout="row" fxLayoutAlign="end" class="footer">
        <span style="margin-right: auto; color: #f44336; font-weight: 500">
          {{ "You have unsaved changes" | translate }}{{ "." }}
          {{ "Do you really want to discard them" | translate }}{{ "?" }}
        </span>
        <button class="save-btn" nz-button nzDanger (click)="confirmDiscard()">
          {{ "Yes" | translate }}
        </button>
        <button class="cancel-btn" nz-button (click)="cancelDiscard()">
          {{ "No" | translate }}
        </button>
      </div>
      }
    </form>
  </ng-container>
</nz-modal>
